import Footer from '../../sections/footer/Footer'
import HeaderSolid from '../../sections/header/HeaderSolid'

import './style.scss'
import CtaButton from '../../components/ctaButton/CtaButton'
import { PAGE_URLS } from '../../constants/hrefLinks'

function ThankYou() {
	
	return (
		<>
			<div className='section-wrap section-seperator'>
				<HeaderSolid />
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<div className='thank-you-content'>
						<div className='sign-up-content-section'>
							<div className='thank-you-message-wrap'>
								<div className='thank-you-message'>
									Thank you for registering, you will receive an email shortly
								</div>
								<div className='thank-you-sub-message'>
									This can take a few minutes and may appear in your spam folder.
								</div>
								<div className='thank-you-button-wrap'>
									<CtaButton
										label='Back to Home'
										onClick={() => {
											window.location.replace(PAGE_URLS.SEARCH)
										}}
										size='medium'
										fullWidth={true}
									/>
									<CtaButton
										label='Sign In'
										onClick={() => {
											window.location.replace(PAGE_URLS.LOG_IN)
										}}
										size='medium'
										fullWidth={true}
									/>
								</div>
							</div>
						</div>
						<div className='sign-up-content-section'>
							<img
								className='sign-up-picture'
								alt='Ski Lift'
								src='/imgs/pictures/skiing.png'
							/>
						</div>
					</div>
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
		</>
	)
}

export default ThankYou
